const initialState = {
    loading: false,
    data: undefined,
    error: null
};

// Dashboard reducer
export const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DASHBOARD_REQUEST':
            return {
                ...state,
                loading: true,
                error: null
            };
        case 'DASHBOARD_SUCCESS':
            return {
                ...state,
                loading: false,
                data: action.payload
            };
        case 'DASHBOARD_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default dashboardReducer; 